import React from 'react';
import { Box, Heading, Text, VStack, Divider, List, ListItem, ListIcon } from '@chakra-ui/react';
import { CheckCircleIcon } from '@chakra-ui/icons';
import TeamSection from './TeamSection';

const AboutUsSection: React.FC = () => {
  return (
    <Box maxW="1200px" mx="auto" py={{ base: 8, md: 12, lg: 16 }} px={{ base: 4, md: 6, lg: 8 }}>
      <Heading
        as="h2"
        mb={{ base: 6, md: 8, lg: 10 }}
        textAlign="center"
        fontSize={{ base: '3xl', md: '4xl', lg: '5xl' }}
        color="primary.600"
      >
        Quiénes Somos
      </Heading>

      <VStack spacing={{ base: 8, md: 10, lg: 12 }} align="stretch">
        {/* Historia */}
        <Box>
          <Text fontSize={{ base: 'md', md: 'lg' }} lineHeight={{ base: '1.7', md: '1.8' }} color="gray.700">
            La idea de TokenMeet nace en 2017, cuando descubrimos la tecnología blockchain y los tokens. Pensamos:
            <Text as="span" fontWeight="semibold" color="primary.600"> "Esto puede cambiar cosas de verdad; puede ayudar a personas y empresas a tomar el control, a participar de forma más profunda y a crear nuevas oportunidades."</Text>
            {' '}Empezamos a aprender, a compartir la visión y a acercarnos a gente con la misma ilusión.
          </Text>
          <Text fontSize={{ base: 'md', md: 'lg' }} lineHeight={{ base: '1.7', md: '1.8' }} color="gray.700" mt={4}>
            Durante un tiempo, otras responsabilidades nos frenaron. Hasta que en noviembre de 2023 decidimos dar el paso y convertir la idea en proyecto. Hablamos, escuchamos y fuimos construyendo un equipo profesional y humano que no solo domina lo técnico, sino que comparte nuestros valores.
          </Text>
          <Text fontSize={{ base: 'md', md: 'lg' }} lineHeight={{ base: '1.7', md: '1.8' }} color="gray.700" mt={4}>
            ¿Por qué ofrecemos más cosas ahora? Porque, tal y como comenzó, TokenMeet fue incorporando más servicios gracias al talento que nos rodea. Por fin se construyó TokenMeet con todo este valor humano. Para nosotros, cada cliente es especial, grande o pequeño. Lo primero es ayudar y ver cómo mejora su negocio con nuestra colaboración. Eso nos hace felices.
          </Text>
        </Box>

        <Divider borderColor="gray.300" />

        {/* Misión */}
        <Box>
          <Heading
            as="h3"
            mb={4}
            fontSize={{ base: 'xl', md: '2xl', lg: '3xl' }}
            color="primary.600"
          >
            Misión
          </Heading>
          <Text fontSize={{ base: 'md', md: 'lg' }} lineHeight={{ base: '1.7', md: '1.8' }} color="gray.700" mb={4}>
            Hacer que más personas y empresas accedan, entiendan y se beneficien de las oportunidades de la innovación digital (tokenización, Web3, IA y experiencias interactivas), con claridad y a un coste justo.
          </Text>
          <List spacing={3}>
            <ListItem display="flex" alignItems="flex-start">
              <ListIcon as={CheckCircleIcon} color="primary.500" mt={1} fontSize="xl" />
              <Text fontSize={{ base: 'md', md: 'lg' }} lineHeight={{ base: '1.7', md: '1.8' }} color="gray.700">
                Enseñar de forma sencilla por qué merece la pena y qué beneficios aporta.
              </Text>
            </ListItem>
            <ListItem display="flex" alignItems="flex-start">
              <ListIcon as={CheckCircleIcon} color="primary.500" mt={1} fontSize="xl" />
              <Text fontSize={{ base: 'md', md: 'lg' }} lineHeight={{ base: '1.7', md: '1.8' }} color="gray.700">
                Compartir conocimiento y experiencias reales.
              </Text>
            </ListItem>
            <ListItem display="flex" alignItems="flex-start">
              <ListIcon as={CheckCircleIcon} color="primary.500" mt={1} fontSize="xl" />
              <Text fontSize={{ base: 'md', md: 'lg' }} lineHeight={{ base: '1.7', md: '1.8' }} color="gray.700">
                Desarrollar soluciones útiles que generen impacto medible.
              </Text>
            </ListItem>
            <ListItem display="flex" alignItems="flex-start">
              <ListIcon as={CheckCircleIcon} color="primary.500" mt={1} fontSize="xl" />
              <Text fontSize={{ base: 'md', md: 'lg' }} lineHeight={{ base: '1.7', md: '1.8' }} color="gray.700">
                Acompañar desde el minuto uno: idea, diseño, legal, desarrollo, lanzamiento y crecimiento.
              </Text>
            </ListItem>
            <ListItem display="flex" alignItems="flex-start">
              <ListIcon as={CheckCircleIcon} color="primary.500" mt={1} fontSize="xl" />
              <Text fontSize={{ base: 'md', md: 'lg' }} lineHeight={{ base: '1.7', md: '1.8' }} color="gray.700">
                Crear comunidad alrededor de proyectos con propósito.
              </Text>
            </ListItem>
            <ListItem display="flex" alignItems="flex-start">
              <ListIcon as={CheckCircleIcon} color="primary.500" mt={1} fontSize="xl" />
              <Text fontSize={{ base: 'md', md: 'lg' }} lineHeight={{ base: '1.7', md: '1.8' }} color="gray.700" fontWeight="semibold">
                En resumen: ayudarte a estar mejor y a ser un poco más feliz con tu proyecto funcionando.
              </Text>
            </ListItem>
          </List>
        </Box>

        <Divider borderColor="gray.300" />

        {/* Cómo lo conseguimos */}
        <Box>
          <Heading
            as="h3"
            mb={4}
            fontSize={{ base: 'xl', md: '2xl', lg: '3xl' }}
            color="primary.600"
          >
            Cómo lo conseguimos
          </Heading>
          <Text fontSize={{ base: 'md', md: 'lg' }} lineHeight={{ base: '1.7', md: '1.8' }} color="gray.700">
            Con cariño, humildad y paciencia. Nuestro equipo está preparado y, sobre todo, implicado. Sí, es un negocio; pero también es una cadena de colaboración: cuando alguien llega a TokenMeet, queremos que sienta nuestro aprecio y que no camina solo.
          </Text>
          <Text fontSize={{ base: 'md', md: 'lg' }} lineHeight={{ base: '1.7', md: '1.8' }} color="gray.700" mt={4}>
            Vengas de donde vengas y sepas lo que sepas, encontrarás quien te explique en claro, y si lo necesitas, abogados, desarrolladores y expertos en marketing listos para ayudarte. Hacemos las cosas paso a paso y a medida.
          </Text>
        </Box>

        <Divider borderColor="gray.300" />

        {/* Cómo trabajamos */}
        <Box>
          <Heading
            as="h3"
            mb={4}
            fontSize={{ base: 'xl', md: '2xl', lg: '3xl' }}
            color="primary.600"
          >
            Cómo trabajamos
          </Heading>
          <VStack align="stretch" spacing={4}>
            <Box
              p={4}
              borderLeft="4px solid"
              borderColor="primary.500"
              bg="gray.50"
              borderRadius="md"
            >
              <Heading as="h4" fontSize={{ base: 'md', md: 'lg' }} color="primary.600" mb={2}>
                1. Escucha y diagnóstico
              </Heading>
              <Text fontSize={{ base: 'sm', md: 'md' }} lineHeight="1.7" color="gray.700">
                Entendemos tu idea y tu situación real.
              </Text>
            </Box>

            <Box
              p={4}
              borderLeft="4px solid"
              borderColor="primary.500"
              bg="gray.50"
              borderRadius="md"
            >
              <Heading as="h4" fontSize={{ base: 'md', md: 'lg' }} color="primary.600" mb={2}>
                2. Propuesta clara
              </Heading>
              <Text fontSize={{ base: 'sm', md: 'md' }} lineHeight="1.7" color="gray.700">
                Objetivos, pasos, plazos y presupuesto sin letra pequeña.
              </Text>
            </Box>

            <Box
              p={4}
              borderLeft="4px solid"
              borderColor="primary.500"
              bg="gray.50"
              borderRadius="md"
            >
              <Heading as="h4" fontSize={{ base: 'md', md: 'lg' }} color="primary.600" mb={2}>
                3. Desarrollo y validación
              </Heading>
              <Text fontSize={{ base: 'sm', md: 'md' }} lineHeight="1.7" color="gray.700">
                Entregas cortas, pruebas con usuarios y mejoras continuas.
              </Text>
            </Box>

            <Box
              p={4}
              borderLeft="4px solid"
              borderColor="primary.500"
              bg="gray.50"
              borderRadius="md"
            >
              <Heading as="h4" fontSize={{ base: 'md', md: 'lg' }} color="primary.600" mb={2}>
                4. Lanzamiento y crecimiento
              </Heading>
              <Text fontSize={{ base: 'sm', md: 'md' }} lineHeight="1.7" color="gray.700">
                Marketing, analítica, soporte y roadmap de evolución.
              </Text>
            </Box>
          </VStack>
        </Box>
      </VStack>

      <Box mt={{ base: 10, md: 12, lg: 16 }}>
        <TeamSection />
      </Box>
    </Box>
  );
};

export default AboutUsSection;
